import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UiFormControlLabel from 'ui-components/ui-form-control-label/UiFormControlLabel';
import UiCheckbox from 'ui-components/ui-checkbox/UiCheckbox';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentSlice } from 'utils';

const subjectList = [
  { title: 'سیاست', id: 'political' },
  { title: 'دیپلماسی و بين‌الملل', id: 'international' },
  { title: 'اقتصاد و تجارت', id: 'economy_and_business' },
  { title: 'جامعه', id: 'society' },
  { title: 'فرهنگ‌،هنر و ادبیات', id: 'culture_art_literature' },
  { title: 'دین‌و‌انديشه', id: 'religion' },
  { title: 'ایثار و مقاومت', id: 'sacrifice_and_resistence' },
  { title: 'تاریخ', id: 'history' },
  { title: 'ورزش', id: 'sports' },
  { title: 'اخبار داخلی', id: 'local' },
  { title: 'آموزش و دانشگاه', id: 'university' },
  { title: 'حوادث', id: 'incident' },
  { title: 'صنعت و معدن', id: 'industry' },
  { title: 'فناوری', id: 'technology' },
  { title: 'انرژی', id: 'energy' },
  { title: 'حقوقی و قضایی', id: 'law_and_judicial' },
  { title: 'سینما و تلویزیون', id: 'cinema_and_tv' },
  { title: 'سلامت و پزشکی', id: 'health' },
];

export const SubjectFilter = (props) => {
  const dispatch = useDispatch();
  const { componentName, className, parentPlatform } = props;
  const filterOption = useSelector((state) =>
    parentPlatform
      ? state[state.filterReducer.filtersContext].filters[parentPlatform][
          componentName
        ]
      : state[state.filterReducer.filtersContext].filters[componentName]
  );

  const reducerName = useSelector(
    (state) => state.filterReducer.filtersContext
  );
  const { selectedIds } = filterOption;
  const { setSelectedFilterIds } = getCurrentSlice(reducerName);

  const handleChangeSubject = (event, id) => {
    dispatch(
      setSelectedFilterIds({
        id,
        isChecked: event.target.checked,
        componentName,
        parentPlatform,
      })
    );
  };

  return (
    <div className={classNames('grid', className)}>
      {subjectList?.map(({ id, title }) => {
        return (
          <UiFormControlLabel
            key={id}
            className='mr-0'
            label={title}
            data-testid={`filter-subject-${id}-label`}
            control={
              <UiCheckbox
                checked={selectedIds?.includes(id)}
                name={id}
                onChange={(event) => handleChangeSubject(event, id)}
                inputProps={{ 'data-testid': `filter-subject-${id}-checkbox` }}
                disabled={filterOption?.isDisabled}
              />
            }
          />
        );
      })}
    </div>
  );
};

SubjectFilter.propTypes = {
  componentName: PropTypes.string.isRequired,
  parentPlatform: PropTypes.string,
  className: PropTypes.string,
};
